
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Aerosol-Forscher kritisieren den «Jama»-Artikel und sind gegenteiliger
  Ansicht: «Sicherlich sind Aerosol-Ansteckungen nicht selten, im Gegenteil, sie
  sind die vorherrschende Übertragungsart», sagt Lidia Morawska. Die Direktorin
  des Internationalen Laboratoriums für Luftqualität und Gesundheit an der
  Queensland University of Technology im australischen Brisbane war <Link allowWordWrap href='https://academic.oup.com/cid/advance-article/doi/10.1093/cid/ciaa939/5867798' mdxType="Link">Erstautorin
  des offenen Briefs</Link> vom Juli, in welchem über 200 Fachleute die WHO dazu
  aufforderten, die Bedeutung von Aerosol-Übertragungen endlich ernst zu nehmen.
    </p>
    <p>
  Dass Sars-CoV-2 weniger ansteckend sei als die Masern, sei kein Beweis dafür,
  dass das Coronavirus nicht auch über die Luft übertragen werden könne. Es gebe
  keinen Grund, anzunehmen, dass die Natur nur hochansteckende Krankheiten
  hervorbringe, die über die Luft übertragbar seien.
    </p>
    <p>
  Es kam in den <Link href='367341950277' allowWordWrap mdxType="Link">letzten Monaten öfter zu Ansteckungen</Link>, obwohl der
  Sicherheitsabstand von 1,5 oder 2 Metern eingehalten wurde. Diese Menschen
  wurden also nicht angehustet. Sie waren einfach länger im gleichen Raum wie
  bereits Infizierte. Die Wahrscheinlichkeit ist gross, dass diese Ansteckungen
  über Aerosole passierten und nicht über Tröpfcheninfektion. Dass der Erreger
  also über die Atemluft in die Lunge geraten ist.
    </p>
    <Image file={require("images/niesen.gif")} proportions="16:8" className='cbImage noMargin' mdxType="Image" />
    <div className='caption'>Immer in Taschentuch oder Armbeuge niesen: Durch Husten und Niesen können sich Viren weit verbreiten. Quelle: Lydia Bourouiba, Professor John Bush, MIT</div>
    <p>
  Auch die Covid-19-Science-Taskforce des Bundes schreibt in einem ihrer <Link icon='file pdf outline' href='https://ncs-tf.ch/de/policy-briefs/the-role-of-aerosols-in-sars-cov-2-transmission-29-oct-20-en-2/download' allowWordWrap mdxType="Link">Policy
  Briefs</Link>, das Coronavirus könne auch über Schwebeteilchen durch die Luft
  übertragen werden. Der Expertengruppe zufolge zeigt sich, dass Aerosole bei
  Superverbreitungsereignissen in Innenräumen mit schlechter Belüftung und
  insbesondere mit Aktivitäten wie Reden, Singen, Schreien und körperlicher
  Betätigung eine wichtige Rolle spielten.
    </p>
    <p>
  Die Experten raten Menschen zum Tragen von Gesichtsmasken in Innenräumen trotz
  Mindestabstand von 1,5 Metern, insbesondere in schlecht belüfteten Räumen, in
  denen man sich längere Zeit aufhält. Weiter empfehlen sie eine angemessene
  Lüftung, grosse Menschenansammlungen in Innenräume zu vermeiden, nur kurze
  Aufenthalte in schlecht belüfteten Räumen und möglichst den Verzicht auf
  Aktivitäten mit hohem Aerosol-Ausstoss.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;